import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import axios from "axios";
import {
  Table,
  Button,
  Row,
  Col,
  ButtonGroup,
  Input,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner
} from "reactstrap";
import Header from "../../../layout/Header/Header";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import moment from "moment";
import Baja from "../../Baja"

function ListadoGastosGeneral() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_GASTOS_GENERAL = process.env.REACT_APP_URL_GASTOS_GENERAL;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const AREAS_GENERAL = process.env.REACT_APP_AREAS_GENERAL;
  const URL_BANCOS = process.env.REACT_APP_URL_BANCOS;
  const URL_EMPRESAS = process.env.REACT_APP_URL_EMPRESAS;
  const URL_CATEGORIAS = process.env.REACT_APP_URL_CATEGORIAS;
  const URL_SUB_CATEGORIAS = process.env.REACT_APP_URL_SUB_CATEGORIAS;
  const URL_SOLICITANTES = process.env.REACT_APP_URL_SOLICITANTES;
  const URL_UPMEDIA = process.env.REACT_APP_URL_UPMEDIA;
  const URL_DELMEDIA = process.env.REACT_APP_URL_DELMEDIA;

  let hoy = new Date()
  let inicio = new Date()
  inicio.setDate(inicio.getDate()-30);
 
  let endDate   = moment(hoy).format("YYYY-MM-DD"); 
  let startDate   = moment(inicio).format("YYYY-MM-DD");

  const [gastos, setGastos] = useState([]);

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [bancos, setBancos] = useState([]);
  const [selectedBanco, setSelectedBanco] = useState("");

  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);
  const [idEdit, setIdEdit] = useState();
  const [fecha, setFecha] = useState();
  const [subtotal, setSubtotal] = useState();
  const [subtotalViejo, setSubtotalViejo] = useState();
  const [iva, setIva] = useState();
  const [ivaViejo, setIvaViejo] = useState();
  const [descripcion, setDescripcion] = useState("");
  const [totalEdit, setTotalEdit] = useState(0);
  const [totalEditViejo, setTotalEditViejo] = useState(0);
  const [categorias, setCategorias] = useState([]);
  const [selectedCategoria, setSelectedCategoria] = useState("");
  const [subCategorias, setSubCategorias] = useState([]);
  const [selectedSubCategoria, setSelectedSubCategoria] = useState("");
  const [solicitantes, setSolicitantes] = useState([]);
  const [selectedSolicitante, setSelectedSolicitante] = useState("");
  const [idBancoEdit, setIdBancoEdit] = useState("");
  const [totalTablaGeneral, setTotalTablaGeneral] = useState(0);
  const [empresas, setEmpresas] = useState([]);
  const [selectedEmpresa, setSelectedEmpresa] = useState("");
  const [selectedFotoEvidencia, setSelectedFotoEvidencia] = useState("");

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  /** Evidencia */
  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);
  const [validaBoton, setValidaBoton] = useState(true);
  const [totalCaptura, setTotalCaptura] = useState(1000000);

  const [idEvidencia, setidEvidencia] = useState("");
  const [fileFotoEvidencia, setFileFotoEvidencia] = useState();
  const [fotoEvidencia, setFotoEvidencia] = useState("No");
  const [photo, setPhoto] = useState();
  const [modalEvidencia, setModalEvidencia] = useState(false);
  const toggleEvidencia = () => setModalEvidencia(!modalEvidencia);
  const [photoEvidencia, setPhotoEvidencia] = useState([]);
  const [modalVerFotoEvidencia, setModalVerFotoEvidencia] = useState(false);
  const toggleVerFotoEvidencia = () => setModalVerFotoEvidencia(!modalVerFotoEvidencia);

  useMemo(() => {
      axios
        .get(
          `${URL_GASTOS_GENERAL}GastosDiarioGeneral/${selectedFechaInicio}/${selectedFechaFin}`,
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then((response) => {
          let allGastos = response.data;
          let arrayTabla = allGastos
            .sort((a, b) => (a.fecha < b.fecha ? 1 : -1))
            .map((a) => {
              return {
                _id: a._id,
                is_active: a.is_active,
                fecha: a.fecha,
                descripcion: a.descripcion,
                subtotal: a.subtotal,
                iva: a.iva,
                total: a.total,
                categoria: a.categorias[0].name,
                idCategoria: a.categorias[0]._id,
                subCategoria: a.subCategorias[0].name,
                idSubCategoria: a.subCategorias[0]._id,
                solicitante: a.solicitantes[0].name,
                idSolicitante: a.solicitantes[0]._id,
                banco: a.bancos[0].banco + a.bancos[0].cuenta,
                idBanco: a.bancos[0]._id,
                fotoEvidencia: a.fotoEvidencia,
                idEmpresa: a.empresas[0]._id,
                empresa: a.empresas[0].name,
              };
            })
            .filter(function (el) {
              return el != null;
            });

          let dataFinal = Object.values(arrayTabla);
          setComments(dataFinal);
          setGastos(dataFinal);
        })
        .catch((err) => {
          console.log(err);
        });
  }, [user, selectedFechaInicio, selectedFechaFin]);

  useEffect(() => {


    axios
        .get(URL_CATEGORIAS, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((res) => {
          const allCategorias = res.data;
          setCategorias(allCategorias);
        })
        .catch((err) => {
          console.log(err);
        });

        axios
        .get(URL_EMPRESAS, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((res) => {
          const allEmpresas = res.data;
          setEmpresas(allEmpresas);
        })
        .catch((err) => {
          console.log(err);
        });

        axios
        .get(URL_SUB_CATEGORIAS, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((res) => {
          const allSubCategorias = res.data;
          setSubCategorias(allSubCategorias);
        })
        .catch((err) => {
          console.log(err);
        });
        
      axios
      .get(URL_SOLICITANTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allSolicitantes = res.data;
        setSolicitantes(allSolicitantes);
      })
      .catch((err) => {
        console.log(err);
      });

      axios
        .get(URL_BANCOS, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((res) => {
          const allBancos = res.data;
          setBancos(allBancos);
        })
        .catch((err) => {
          console.log(err);
        });

    }, []);

  let total = 0;
  let totalTabla = 0;

  function PDFTabla() {
    total = 0;
    const data = comments.map((c) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= c.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= c.fecha) &&
        (selectedBanco == 0 || selectedBanco == c.idBanco)&&
        (selectedEmpresa == 0 || selectedEmpresa == c.idEmpresa)&&
        (selectedFotoEvidencia == 0 || selectedFotoEvidencia == c.fotoEvidencia)
      ) {
        total = total + c.total;
        const importePDF = new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(c.total);
        return [c.fecha, c.empresa, c.categoria, c.descripcion, c.banco, importePDF];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 10, 35, 30);
    doc.text("Detalle de Gastos", 20, 25);
    doc.autoTable({
      head: [["Fecha", "Empresa", "Categoria", "Descripcion", "Banco", "Importe"]],
      body: dataPDFLimpia,
 headStyles: {
            fillColor: ["#00313c"],
            lineWidth: 0
          },
          footStyles: {
            fillColor: ["#00313c"],
          },
          theme:"grid",
      startY: 45,
      foot: [
        ["", "", "", "", "Total", new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(total)],
      ],
      showFoot: "lastPage",
    });
    doc.save("DetalleGastos.pdf");
  }

  function excel() {
    const dataExcel = comments.map((c) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= c.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= c.fecha) &&
        (selectedBanco == 0 || selectedBanco == c.idBanco) &&
        (selectedEmpresa == 0 || selectedEmpresa == c.idEmpresa)&&
        (selectedFotoEvidencia == 0 || selectedFotoEvidencia == c.fotoEvidencia)
      ) {
        return {
          Fecha: c.fecha,
          Empresa: c.empresa,
          Categoria: c.categoria,
          Subcategoria: c.subCategoria,
          Solicitante: c.solicitante,
          Descripcion: c.descripcion,
          Banco: c.banco,
          Importe: c.total,
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = `DetalleGastos-${selectedFechaInicio}-${selectedFechaFin}`;

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: `DetalleGastos`,
        sheetFilter: ["Fecha", "Empresa", "Categoria", "Subcategoria", "Solicitante", "Descripcion", "Banco", "Importe"],
        sheetHeader: ["Fecha", "Empresa", "Categoria", "Subcategoria", "Solicitante", "Descripcion", "Banco", "Importe"],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    total = 0;
    const data = gastos.map((c) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= c.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= c.fecha) &&
        (selectedBanco == 0 || selectedBanco == c.idBanco)
      ) {
        total = total + c.total;
        const importePDF = new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(c.total);
        return [c.fecha, c.categoria, c.descripcion, c.banco, importePDF];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 10, 35, 30);
    doc.text("Detalle de Gastos", 20, 25);
    doc.autoTable({
      head: [["Fecha", "Categoria", "Descripcion", "Banco", "Importe"]],
      body: dataPDFLimpia,
 headStyles: {
            fillColor: ["#00313c"],
            lineWidth: 0
          },
          footStyles: {
            fillColor: ["#00313c"],
          },
          theme:"grid",
      startY: 45,
      foot: [
        ["", "", "", "Total", new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(total)],
      ],
      showFoot: "lastPage",
    });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Lista de Gastos",
          email: mailTo,
          fileName: "ListaGastos.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras la lista de Gastos.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  const editGasto = (event) => {
    const URL_GASTOS_GENERAL_EDIT = `${process.env.REACT_APP_URL_GASTOS_GENERAL}/${idEdit}`;
    event.preventDefault();
        axios.patch(
          URL_GASTOS_GENERAL_EDIT,
          {
            fecha,
            subtotal: parseFloat(subtotal) - parseFloat(subtotalViejo),
            iva: parseFloat(iva) - parseFloat(ivaViejo),
            total: parseFloat(totalEdit) - parseFloat(totalEditViejo),
            descripcion,
            areas: AREAS_GENERAL,
            categorias:selectedCategoria,
            subCategorias:selectedSubCategoria,
            solicitantes:selectedSolicitante,
            bancos: idBancoEdit
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: "Edit Gasto",
            detalle: `Fecha: ${fecha} / Descripcion: ${descripcion} `,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
        Swal.fire("Good job!", "Actualizado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  };

  const headers = [
    { name: "Fecha", field: "fecha", sortable: true },
    { name: "Empresa", field: "empresa", sortable: true },
    { name: "Categoria", field: "categoria", sortable: true },
    { name: "SubCategoria", field: "subCategoria", sortable: true },
    { name: "Solicitante", field: "solicitante", sortable: true },
    { name: "Descripcion", field: "descripcion", sortable: true },
    { name: "Banco", field: "banco", sortable: true },
    { name: "Importe", field: "total", sortable: true },
    { name: "Acciones", field: "acciones", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.categoria.toLowerCase().includes(search.toLowerCase()) ||
          comment.subCategoria.toLowerCase().includes(search.toLowerCase()) ||
          comment.solicitante.toLowerCase().includes(search.toLowerCase()) ||
          comment.descripcion.toLowerCase().includes(search.toLowerCase()) ||
          comment.empresa.toLowerCase().includes(search.toLowerCase()) ||
          comment.banco.toLowerCase().includes(search.toLowerCase())||
          comment.total.toString().includes(search) 
      );
    }
    if (selectedBanco) {
      computedComments = computedComments.filter((e) =>
        e.idBanco.includes(selectedBanco)
      );
    }

    if (selectedEmpresa) {
      computedComments = computedComments.filter((e) =>
        e.idEmpresa.includes(selectedEmpresa)
      );
    }


    if (selectedFotoEvidencia) {
      computedComments = computedComments.filter((e) =>
        e.fotoEvidencia.includes(selectedFotoEvidencia)
      );
    }

    setTotalItems(computedComments.length);

    let car = computedComments.map((c) => parseFloat(c.total));
    let TCar = car.reduce((t, total, index) => t + total, 0);
    setTotalTablaGeneral(TCar);

     //Sorting comments
     if (
      sorting.field &&
      sorting.field != "total"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "total")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "total")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }
    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedFechaInicio,
    selectedFechaFin,
    selectedBanco,
    selectedEmpresa,
    selectedFotoEvidencia
  ]);

  const calcula = (e) => {
    setSubtotal(e);
    setTotalEdit(parseFloat(e) + parseFloat(iva));
  };

  const calculaIVA = (e) => {
    setIva(e);
    setTotalEdit(parseFloat(subtotal) + parseFloat(e));
  };

  function jalaInfo(id, subtotal, iva, total, categoria, subCategoria, solicitante, descripcion, fecha, idBanco){
    setIdEdit(id)
    setSubtotalViejo(subtotal)
    setSubtotal(subtotal)
    setIvaViejo(iva)
    setIva(iva)
    setTotalEditViejo(total)
    setTotalEdit(total)
    setSelectedCategoria(categoria)
    setSelectedSubCategoria(subCategoria)
    setSelectedSolicitante(solicitante)
    setDescripcion(descripcion)
    setFecha(fecha)
    setIdBancoEdit(idBanco)
    toggleEdit()
  }

  function cancelarGasto(idGasto) {
    Swal.fire({
      title: "Estas seguro?",
      text: "Se cancelara el Gasto!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Cancelar!",
    }).then((result) => {
      if (result.isConfirmed) {
    axios
      .get(`${URL_GASTOS_GENERAL}Cancel/${idGasto}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then(() => {
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
    }
  });
  }

  function saveFotoEvidencia() {
    if (idEvidencia != "") {
      Swal.fire({
        title: `Por favor espere...`,
        html: "data uploading", 
        allowOutsideClick: false,
        onBeforeOpen: () => {
          Swal.showLoading();
        },
      });

      const formData = new FormData();
      formData.append("file", fileFotoEvidencia);
      formData.append("nombre", `${idEvidencia}`);

      axios
      .post(URL_UPMEDIA, formData, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
        .then(() => {
          setFotoEvidencia("Si");
          axios
            .patch(
              `${URL_GASTOS_GENERAL}/${idEvidencia}`,
              {
                fotoEvidencia: "Si",
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            )
            .then(() => {
              Swal.fire({
                position: "center",
                icon: "success",
                title: `Se guardaron los datos`,
                showConfirmButton: false,
                timer: 1000,
              });
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: `${error.response.data}`,
              });
              console.log(error);
            });
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
          console.log(error);
        })


    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Debes Guardar los cambios antes de subir las fotos",
      });
    }
  }

  function jalaFotoEvidencia() {
    const URL_GET_MEDIA = `${process.env.REACT_APP_URL_FINDMEDIABYTAG}/${idEvidencia}`;
    axios
      .get(URL_GET_MEDIA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((data) => {
          setPhotoEvidencia(data.data.resources);
      })
      .catch((err) => console.log(err));
    toggleVerFotoEvidencia();
  }

  function borrarFoto(id) {
    axios.post(`${URL_DELMEDIA}/${id}`, {}, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })

    .then(() => {

      Swal.fire("Good job!", "Actualizado con exito", "success");
      setTimeout(() => {
        window.location.reload();
      }, 1000);

    })
    .catch((error) => {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response.data}`,
      });
      console.log(error);
    });
    

    // setFile();
    // setPhoto([]);
  }


  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_gastos ? (
        <div className="row">
          <div className="col-md-12">
            <div className="card style={{ width: 'auto' }}">
              <div className="card-body">
                <Row>
                  <Col md={7}>
                    {user.menu_gastos ? (
                      <Button
                        size="sm"
                        href="/GastosCreate"
                        className="btn btn-success"
                        id="botonListado"
                      >
                        Crear Gasto
                      </Button>
                    ) : (
                      <Button
                        size="sm"
                        disabled
                        className="btn btn-success"
                        id="botonListado"
                      >
                        Crear Gasto
                      </Button>
                    )}
                    <Button
                      size="sm"
                      href="/MenuGastos"
                      className="btn btn-danger"
                      id="botonListado"
                    >
                      Regresar
                    </Button>
                  </Col>
                  <Col md={5}>
                    <ButtonGroup id="logoutBoton">
                      <Button
                        size="sm"
                        className="btn"
                        color="danger"
                        onClick={PDFTabla}
                      >
                        PDF <i class="far fa-file-pdf"></i>
                      </Button>
                      <Button
                        size="sm"
                        className="btn"
                        color="info"
                        onClick={toggleMail}
                      >
                        eMail <i class="fas fa-at"></i>
                      </Button>
                      <Button
                        size="sm"
                        className="btn"
                        color="primary"
                        onClick={excel}
                      >
                        Excel <i class="far fa-file-excel"></i>
                      </Button>
                    </ButtonGroup>
                  </Col>
                </Row>
                <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
                  <ModalHeader toggle={toggleMail}>
                    <h4>Enviar Lista de Gastos</h4>
                  </ModalHeader>
                  <ModalBody>
                    <Label className="mr-sm-2">Email</Label>
                    <Input
                      className="col-sm-12"
                      type="text"
                      value={mailTo}
                      required
                      onChange={(e) => {
                        setMailTo(e.target.value);
                      }}
                    />
                  </ModalBody>
                  <ModalFooter>
                    <Button size="sm" color="success" onClick={enviaMail}>
                      Enviar
                    </Button>
                  </ModalFooter>
                </Modal>

                <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
             <h4> Este proceso puede tardar varios segundos.
              <br />
              Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                  <Spinner
                    style={{
                      width: "50px",
                      height: "50px",
                      color: "#232B41",
                    }}
                  />
                  <Spinner
                    style={{
                      width: "50px",
                      height: "50px",
                      color: "#232B41",
                    }}
                  />
                  <Spinner
                    style={{
                      width: "50px",
                      height: "50px",
                      color: "#232B41",
                    }}
                  />
              </div>
            </ModalBody>
          </Modal>

          <Modal size="lg" isOpen={modalEvidencia} toggle={toggleEvidencia}>
        <ModalHeader toggle={toggleEvidencia}>
          <h4>Evidencias</h4>
        </ModalHeader>
        <ModalBody>
       
          <Row>
                    <Col md={6}>
                      <Label >
                        Fotos
                      </Label>
                      <Input
                        type="file"
                        onChange={(e) => {
                          setFileFotoEvidencia(e.target.files[0]);
                          setFotoEvidencia("No")
                        }}
                      />
                    </Col>
                    {fileFotoEvidencia && fotoEvidencia == "No" ? (
                      <Button
                        color="gris"
                        className="btn btn-gris"
                        size="sm"
                        onClick={(e) => {
                          saveFotoEvidencia();
                        }}
                      >
                        Subir
                      </Button>
                    ) : (
                      <Button
                        color="gris"
                        className="btn btn-gris"
                        size="sm"
                        disabled
                      >
                        Subir
                      </Button>
                    )}
                    {fotoEvidencia == "Si" ? (
                      <Button
                        color="gris"
                        className="btn btn-gris"
                        size="sm"
                        onClick={(e) => {
                          jalaFotoEvidencia();
                        }}
                      >
                        Ver
                      </Button>
                    ) : undefined}
                  </Row>
        </ModalBody>
        <ModalFooter>
        </ModalFooter>
      </Modal>

      <Modal size="xxl" isOpen={modalVerFotoEvidencia} toggle={toggleVerFotoEvidencia}>
        <ModalHeader toggle={toggleVerFotoEvidencia}>
          <h4>Evidencias</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
          {photoEvidencia.length > 0 ? (
              photoEvidencia.map((a)=>{
                return (
                  <h6 style={{ textAlign: "center" }}>
                    <img src={a.secure_url} width="500" height="auto" />
                    <br />
                    <Button
                      color="danger"
                      onClick={() => borrarFoto(a.asset_id)}
                      style={{ marginTop: "10px" }}
                    >
                      Eliminar
                    </Button>
                  </h6>
                ); 
                             
              })
            ) : <h4>No se ha subido una Foto....</h4>}
          </Row>
        </ModalBody>
      </Modal>

                <br />
                <h3 align="center">Gastos</h3>
                <Row>
                  <Col md={2}>
                    <Label>Fecha Inicio</Label>
                    <Input
                      bsSize="sm"
                      type="date"
                      value={selectedFechaInicio}
                      onChange={(e) => {
                        setSelectedFechaInicio(e.target.value);
                      }}
                    />
                  </Col>
                  <Col md={2}>
                    <Label>Fecha Fin</Label>
                    <Input
                      bsSize="sm"
                      type="date"
                      value={selectedFechaFin}
                      onChange={(e) => {
                        setSelectedFechaFin(e.target.value);
                      }}
                    />
                  </Col>
                  <Col md={2}>
                    <Label>Banco</Label>
                    <Input
                      type="select"
                      bsSize="sm"
                      value={selectedBanco}
                      onChange={(e) => {
                        setSelectedBanco(e.target.value);
                      }}
                    >
                      <option value="">Selecciona</option>
                      {bancos
                        .sort((a, b) => (a.banco > b.banco ? 1 : -1))
                        .map((a) => {
                          return (
                            <option value={a._id}>
                              {a.banco} {a.cuenta}
                            </option>
                          );
                        })}
                    </Input>
                  </Col>

                  <Col md={2}>
                    <Label>Empresa</Label>
                    <Input
                      type="select"
                      bsSize="sm"
                      value={selectedEmpresa}
                      onChange={(e) => {
                        setSelectedEmpresa(e.target.value);
                      }}
                    >
                      <option value="">Selecciona</option>
                      {empresas
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((a) => {
                          return (
                            <option value={a._id}>
                              {a.name}
                            </option>
                          );
                        })}
                    </Input>
                  </Col>

                  <Col md={2}>
                    <Label>Evidencia</Label>
                    <Input
                      type="select"
                      bsSize="sm"
                      value={selectedFotoEvidencia}
                      onChange={(e) => {
                        setSelectedFotoEvidencia(e.target.value);
                      }}
                    >
                      <option value="">Selecciona</option>
                      <option value="Si">Si</option>
                      <option value="No">No</option>
                    </Input>
                  </Col>
                </Row>
                <br />
                <div className="row">
                  <div className="col-md-6">
                    <Pagination
                      total={totalItems}
                      itemsPerPage={ITEMS_PER_PAGE}
                      currentPage={currentPage}
                      onPageChange={(page) => setCurrentPage(page)}
                    />
                  </div>
                  <div className="col-md-6 d-flex flex-row-reverse">
                    <Search
                      onSearch={(value) => {
                        setSearch(value);
                        setCurrentPage(1);
                      }}
                    />
                  </div>
                </div>
                <Table
                  size="sm"
                  striped
                  borderless
                  className="table-responsive-xl"
                >
                  <TableHeader
                    headers={headers}
                    onSorting={(field, order) => setSorting({ field, order })}
                  />

                  <tbody>
                    {commentsData.map((c) => {
                      if(c.is_active == "Si"){
                      totalTabla = totalTabla + c.total;
                      return (
                        <tr style={{ backgroundColor: c.fotoEvidencia === "No" ? "#fff8b3" : "" }}>
                          <td>{c.fecha}</td>
                          <td>{c.empresa}</td>
                          <td>{c.categoria}</td>
                          <td>{c.subCategoria}</td>
                          <td>{c.solicitante}</td>
                          <td>{c.descripcion}</td>
                          <td>{c.banco}</td>
                          <td>
                            {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(c.total)}
                          </td>
                          <td>
                          <Button
                              color="info"
                              id="Editar"
                              size="sm"
                              onClick={(e) => jalaInfo(c._id, c.subtotal, c.iva, c.total, c.idCategoria, c.idSubCategoria, c.idSolicitante, c.descripcion, c.fecha, c.idBanco)}
                            >
                              <i class="far fa-edit"></i>{" "}
                            </Button>
                            <Button
                            color="gris" 
                            onClick={e=> {
                              setidEvidencia(c._id)
                              setFotoEvidencia(c.fotoEvidencia)

                              toggleEvidencia()
                            }}
                            size="sm"
                          ><i class="fas fa-file-alt"></i>
                          </Button>
                              <Button
                                  size="sm"
                                  className="btn"
                                  color="danger"
                                  onClick={(e) => cancelarGasto(c._id)}
                                >
                                  <i class="fas fa-ban"></i>
                                </Button>
                          </td>
                        </tr>
                      )}else{
                        return (
                          <tr style={{backgroundColor:"#ed8c8c"}}>
                            <td>{c.fecha}</td>
                            <td>{c.empresa}</td>
                            <td>{c.categoria}</td>
                            <td>{c.subCategoria}</td>
                            <td>{c.solicitante}</td>
                            <td>{c.descripcion}</td>
                            <td>{c.banco}</td>
                            <td>CANCELADO</td>
                            <td>
                            
                              
                            </td>
                          </tr>
                        )
                      }
                    })}
                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td className="negrita" align="center">
                        TOTAL
                      </td>
                      <td className="negrita">
                        {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalTabla)}
                      </td>
                      <td></td>
                    </tr>
                    <tr>
                    <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td className="negrita" align="center">
                        TOTAL GENERAL
                      </td>
                      <td className="negrita">
                        {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalTablaGeneral)}
                      </td>
                      <td></td>
                    </tr>
                  </tbody>
                </Table>
                <div className="col-md-6">
                  <Pagination
                    total={totalItems}
                    itemsPerPage={ITEMS_PER_PAGE}
                    currentPage={currentPage}
                    onPageChange={(page) => setCurrentPage(page)}
                  />
                </div>
              </div>
            </div>
          </div>
         
          <Modal size="lg" isOpen={modalEdit} toggle={toggleEdit}>
            <ModalHeader toggle={toggleEdit}>
              <h4> Editar Gasto</h4>
            </ModalHeader>
            <ModalBody>
            <Row>

            <Col md={6}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Fecha
                </Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fecha}
                  required
                  onChange={(e) => {
                    setFecha(e.target.value);
                  }}
                />
              </Col>
              </Row>
              <Row>
            <Col md={6}>
                <Label className="mr-sm-2">Categoria</Label>
                  <Input
                    // bsSize="sm"
                    type="select"
                    required
                    value={selectedCategoria}
                    onChange={(e) => setSelectedCategoria(e.target.value)}
                  >
                    <option value="0">Selecciona</option>
                    {categorias
                      .sort((a, b) => (a.name > b.name ? 1 : -1))
                      .map((a) => {
                          return <option value={a._id}>{a.name}</option>;
                      })}
                  </Input>
                  </Col>
                  <Col md={6}>
                    <Label className="mr-sm-2">SubCategoria</Label>
                      <Input
                        // bsSize="sm"
                        type="select"
                        required
                        value={selectedSubCategoria}
                        onChange={(e) => setSelectedSubCategoria(e.target.value)}
                      >
                        <option value="0">Selecciona</option>
                        {subCategorias
                          .sort((a, b) => (a.name > b.name ? 1 : -1))
                          .map((a) => {
                              return <option value={a._id}>{a.name}</option>;
                          })}
                      </Input>
                      </Col>
                  </Row>
                  <Row>
                <Col md={6}>
                    <Label className="mr-sm-2">Solicito / Autorizo</Label>
                      <Input
                        // bsSize="sm"
                        type="select"
                        required
                        value={selectedSolicitante}
                        onChange={(e) => setSelectedSolicitante(e.target.value)}
                      >
                        <option value="0">Selecciona</option>
                        {solicitantes
                          .sort((a, b) => (a.name > b.name ? 1 : -1))
                          .map((a) => {
                              return <option value={a._id}>{a.name}</option>;
                          })}
                      </Input>
                      </Col>



              <Col md={6}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Descripcion
                </Label>
                <Input
                  type="text"
                  placeholder="Descripcion"
                  value={descripcion}
                  required
                  onChange={(e) => {
                    setDescripcion(e.target.value);
                  }}
                />
              </Col>
            </Row>

            <Row>
              <Col sm={4}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Subtotal
                </Label>
                <Input
                  type="number"
                  min="0"
                  step="any"
                  placeholder="Subtotal"
                  value={subtotal}
                  required
                  onChange={(e) => calcula(e.target.value)}
                />
              </Col>
              <Col sm={4}>
                <Label for="exampleEmail" className="mr-sm-2">
                  IVA
                </Label>
                <Input
                  type="number"
                  min="0"
                  step="any"
                  placeholder="IVA"
                  value={iva}
                  required
                  onChange={(e) => calculaIVA(e.target.value)}
                />
              </Col>
              <Col sm={4}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Total
                </Label>
                <Input
                  type="number"
                  min="0"
                  step="any"
                  placeholder={totalEdit}
                  disabled
                />
              </Col>
            </Row>

            </ModalBody>
            <ModalFooter>
              <Button color="success" onClick={editGasto}>
                Guardar
              </Button>
            </ModalFooter>
          </Modal>
        </div>
      ) : undefined}
      {loader}
    </>
  );
}

export default ListadoGastosGeneral;
